import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { PlatformContentService } from '../platform-content.service';
import { finalize } from 'rxjs';
import { EditPlatformContentPayload } from '../platform-content.interface';

@Component({
  selector: 'app-edit-platform-content',
  templateUrl: './edit-platform-content.component.html',
  styleUrls: ['./edit-platform-content.component.scss']
})
export class EditPlatformContentComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error
  errorIcon: string = environment.config.customNotifications.icons.error
  errorType: string = environment.config.customNotifications.icons.error

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.title),
    observations: new FormControl(''),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditPlatformContentComponent>,
    private platformContentService: PlatformContentService, 
    private notificationService: NotificationService,
    private authService: AuthService) {
      this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token
      this.platformContentService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const updatedPlatformContent: EditPlatformContentPayload = {
      name: this.form.get('name')?.value,
      observations: this.form.get('observations')?.value,
      id: this.data.id,
    };

    this.platformContentService.updatePlatformContent(updatedPlatformContent)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
      next: () => {
        this.dialogRef.close({success:true})
      },
      error: (err) => {
        let errorMessage = environment.config.customNotifications.generalMessages.error;
        this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon)
      }
    })
  }
}
